export enum DialogTypes {
  changeEmail= "changeEmailModal",
  changeAddress= "changeAddressModal",
  changePassword= "changePasswordModal",
};
export enum ChangePasswordTypes {
  CurrentPassword = "current",
  NewPassword = "new",
  ConfirmPassword = "confirm",
}
